import PropTypes from "prop-types"
import { connect } from "react-redux"

import { addToCart } from "areas/product/store/actions"
import Button from "components/ui/button"

const ItemEditForm = ({
  prefStore,
  wizard,
  choices,
  submitItem,
  validating,
}) => {
  let inputChoices = {}
  Object.keys(choices)
    .filter((key) => {
      return !choices[key].disabled
    })
    .map((key) => {
      if (Object.keys(choices).includes("sc")) {
        if (key.match(/^s[1-9][1-9]?/)) {
          const stonenum = +key.match(/\d+/)[0]
          let scnum = +choices.sc.value
          if (choices?.style_code?.value == "JWL0680") {
            scnum += 1
          }
          if (stonenum <= scnum) {
            inputChoices[key] = choices[key].value
          }
        } else {
          inputChoices[key] = choices[key].value
        }
      } else {
        inputChoices[key] = choices[key].value
        if (/img[0-9]+/.test(key) && choices[key].threshold_value) {
          inputChoices[`${key}_th`] = choices[key].threshold_value
        }
      }
    })
  if (!wizard.formUrl) {
    return ""
  }

  return (
    <div>
      <form
        action={wizard.formUrl}
        id="edit-form"
        method="post"
        onSubmit={(e) => {
          e.preventDefault()
          submitItem(e, validating)
        }}
      >
        <input
          hidden
          name="order_params"
          readOnly
          type="text"
          value={wizard.orderParams}
        />
        {Object.keys(inputChoices).map((key) => {
          return (
            <input
              hidden
              key={key}
              name={key}
              readOnly
              type="text"
              value={
                typeof inputChoices[key] === "object"
                  ? JSON.stringify(inputChoices[key])
                  : inputChoices[key]
              }
            />
          )
        })}
        <div className="mb-16">
          <Button
            className="text-18 w-full"
            data-cy="order-actions-cart-edit-item-next-btn"
            disabled={!prefStore || wizard?.loading || validating}
            loading={validating}
            type="submit"
            variant="primary"
          >
            Update Order
          </Button>
        </div>
      </form>
    </div>
  )
}
const mapStateToProps = (state) => {
  return {
    choices: state.choices,
    prefStore: state.wizardUI.prefStore,
    validating: state.wizardUI.isAddingToCart,
    wizard: state.wizard,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    submitItem: (e, validating) => {
      if (!validating) {
        e.preventDefault()
        dispatch(addToCart())
      }
    },
  }
}

ItemEditForm.propTypes = {
  choices: PropTypes.object,
  prefStore: PropTypes.bool,
  submitItem: PropTypes.func,
  validating: PropTypes.bool,
  wizard: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemEditForm)
